$hyoo_tree_edit $mol_list
	value? $mol_tree2
	enabled true
	rows <= list*0 /
		<= Item*0 $mol_list rows /
			<= Item_row* $mol_view sub <= item_row* /
				<= Item_type* $mol_string_button
					hint \Type
					value? <=> item_type*? \
					enabled <= enabled
				<= Item_value* $mol_string
					hint \Value
					value? <=> item_value*? \
					enabled <= enabled
				<= Item_kind* $mol_check_icon
					hint \Toggle kind
					checked? <=> item_kind*? false
					enabled <= enabled
					sub /
						<= Item_kind_icon* $mol_icon_translate
				<= Item_born* $mol_button_minor
					hint \Add item
					click? <=> item_born*? null
					enabled <= enabled
					sub /
						<= Item_born_icon* $mol_icon_plus
				<= Item_delete* $mol_pick
					hint \Delete
					trigger_enabled <= enabled
					trigger_content /
						<= Item_delete_icon* $mol_icon_delete_outline
					bubble_content /
						<= Item_delete_options* $mol_list rows /
							<= Item_delete_self* $mol_button_minor
								click? <=> item_delete_self*? null
								sub / \Disappear
							<= Item_delete_tree* $mol_button_minor
								click? <=> item_delete_tree*? null
								sub / \Truncate
			<= List* $mol_list rows <= list*
